import { render, staticRenderFns } from "./BrandSelect.vue?vue&type=template&id=ddf4baea&scoped=true&"
import script from "./BrandSelect.vue?vue&type=script&lang=js&"
export * from "./BrandSelect.vue?vue&type=script&lang=js&"
import style0 from "./BrandSelect.vue?vue&type=style&index=0&id=ddf4baea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf4baea",
  null
  
)

export default component.exports